import { getVisitorId } from "../../utils/utils";
import { existDFI } from "./existDFI";
import { existDRP } from "./existDRP";
import { removeElements, searchElementsHidden, showElementsHidden } from "./observerInputsRingpool";
import { saveInboundFisrt, startRingpool, stopRingpool } from "./ringpool";



// Funcion para medir la velocidad del internet
const velocityInternet = async ()=>{
    // @ts-ignore
    var conexion = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conexion && conexion.downlink) {
      var velocidad = conexion.downlink;
  
      // Aquí puedes definir la velocidad para considerar una conexión a 3G o menor
      var umbral3G = 2; // Mbps
  
      if (velocidad <= umbral3G) {
        return await getVisitorId(300);
      } else {
        return await getVisitorId(2000);
      }
    }
  
  }

async function conexionLow(name) {
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            let nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(nameEQ) === 0) {
                    // Usa decodeURIComponent para decodificar el valor de la cookie
                    let valor = decodeURIComponent(c.substring(nameEQ.length, c.length));
                    if (valor) {
                        clearInterval(interval); // Detener el intervalo
                        resolve(valor); // Resolver la promesa con el valor de la cookie
                        break; // Salir del bucle for
                    }
                }
            }
        }, 1000);
    });
  }
  
  
  async function getCookieValue(name) {
    const conexion = await velocityInternet();
    if(conexion<=2){
      const valor = await conexionLow(name);
      return valor;
    }else{
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
          let c = ca[i].trim();
          if (c.indexOf(nameEQ) === 0) {
              // Usa decodeURIComponent para decodificar el valor de la cookie
              return decodeURIComponent(c.substring(nameEQ.length, c.length));
          }
      }
      return null;
    }
    
  }


async function explodeParamCookie(nameCookie, paramBuscar) {
    let queryString = await getCookieValue(nameCookie);
    if (!queryString) {
      return null; // La cookie no tiene valor o no existe
    }
  
    // Dividir la cadena de consulta en pares clave-valor
    let params = queryString.split('&');
    let paramValue = null;
  
    try {
      // Buscar el parámetro y obtener sus valores si existe
      for (let i = 0; i < params.length; i++) {
        let [key, value] = params[i].split('=');
        if (key === paramBuscar) {
          paramValue = value;
          break;
        }
      }
  
      // Si paramValue se encontró, procesar el valor
      if (paramValue !== null) {
        let paramArray = paramValue.split(','); // Separa por comas para obtener cada par id:valor
        let paramPairs = paramArray.map((pair) => {
          let [id, value] = pair.split(':'); // Separa cada par por el dos puntos para obtener id y valor
          return { id, value }; // Retorna un objeto con id y valor
        });
        return paramPairs;
      }
    } catch (error) {
      console.error('Ocurrió un error al procesar el parámetro:', error);
    }
    return null;
  }

  export async function watchCookie(name, paramBuscar) {
   
    if(await existDRP()  && existDFI()){
      stopRingpool();
    }
   
   
    let lastCookieValue = explodeParamCookie(name, paramBuscar);
    
    let timeoutId = null; // ID del timeout para poder cancelarlo más tarde
    const startTime = Date.now(); // Tiempo de inicio para calcular el tiempo transcurrido
    const maxDuration = 2 * 60 * 1000; // Tiempo para parar el observador
  
    const checkCookieChange = async () => {
      // Para el ringpool
      if(await existDRP()  && existDFI()){
        stopRingpool();
      }
      const elementStop=document.querySelector("#onetrust-reject-all-handler")
        if(elementStop){
          elementStop.addEventListener("click",()=>{
             stopRingpool()
             clearTimeout(timeoutId)
             removeElements();
             console.log(`Usuario rechazo la cookie "${name}" : deteniendo la observación y cargando el ringpool`);
             return
          })
         
        }
  
      // Verifica si han pasado X minutos desde que comenzó la observación
      if (Date.now() - startTime >= maxDuration) {
        console.log(`Se ha excedido el tiempo máximo de observación de la cookie "${name}".`);
        return; // Detiene la función si han pasado 5 minutos
      }
  
      let currentCookieValue = await explodeParamCookie(name, paramBuscar);
  
      // Verificar si la condición específica se cumple para detener la observación
      let stopConditionMet = currentCookieValue && currentCookieValue.some(pair => pair.id === 'C0001' && pair.value === '1') && currentCookieValue.some(pair => pair.id === 'C0002' && pair.value === '1');
      if (stopConditionMet) {
        startRingpool(currentCookieValue);
        console.log(`Usuario aceptó la cookie "${name}" tiene el valor específico; deteniendo la observación y cargando el ringpool`);
        return; // Salir de la función si se cumple la condición de parada
      } else {


        
       
          timeoutId = setTimeout(async function() {
            if (JSON.stringify(currentCookieValue) !== JSON.stringify(lastCookieValue)) {
              lastCookieValue = currentCookieValue;
    
              if (!stopConditionMet) {
                checkCookieChange(); // Continuar observando
              } else {
                clearTimeout(timeoutId);
                startRingpool(currentCookieValue);
                console.log(`Usuario aceptó la cookie "${name}" tiene el valor específico; deteniendo la observación y cargando el ringpool`);
                return; // Salir de la función si se cumple la condición de parada
              }
            } else {
              checkCookieChange(); // Vuelve a chequear después de un tiempo
            }
          }, 1000); // Intervalo de sondeo
  
        
      

      }
    };
  
    // Iniciar la observación de la cookie
    checkCookieChange();
  
    // Establecer un límite de tiempo para detener la observación después de 5 minutos
    setTimeout( async() => {
      clearTimeout(timeoutId);
      if(await existDRP() && existDFI()){
        stopRingpool();
      }
      removeElements();
      console.log(`Se ha detenido la observación de la cookie "${name}" después de "${maxDuration}" ms.`);
    }, maxDuration);
  }